<template>
  <select v-model="selectedValue" @change="onChangeEvent(selectedValue)" :style="customStyle">
    <option v-for="option in options" :value="option[formattedValue]">{{option[formattedLabel]}}</option>
  </select>
</template>

<script>
  import _ from "lodash";

  export default {
    name: "cc-select",
    props: {
      options: {
        type: Array,
        required: true
      },
      labelName: {
        type: String,
        required: false
      },
      valueName: {
        type: String,
        required: false
      },
      selected: {
        type: [String, Number],
        required: false
      },
      onChangeEvent: {
        type: Function,
        required: false
      },
      customStyle: {
        type: [String],
        required: false
      }
    },
    beforeMount: function(){
      if (this.selected !== null)
      {
        this.selectedValue = _.cloneDeep(this.selected);
      }
    },
    
    data(){
      return {
        selectedValue: null
      }
    },
    watch: {
      selected: function(value) {
          if (this.selected !== null)
          {
            this.selectedValue = _.cloneDeep(this.selected);
          }
      },
    },

    computed: {
      formattedLabel: function(){
        if (this.labelName !== null && this.labelName !== undefined)
        {
          return this.labelName;
        }
        else
        {
          return 'label';
        }
      },
      formattedValue: function(){
        if (this.valueName !== null && this.valueName !== undefined)
        {
          return this.valueName;
        }
        else
        {
          return 'value';
        }
      }
    },
    methods: {
    }
  }
</script>

<style lang="scss" scoped>
  select {
    padding: 8px 3px;
    border: 1px solid $border-color;
    border-radius: $border-radius;
    background-color: #fff;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    background: url('/static/img/icon-select-arrow.svg') 96% / 15% no-repeat #fff;
    background-size: 1.75em;
    cursor: pointer;
  }
</style>


// WEBPACK FOOTER //
// src/components/common/CCSelect.vue